import { Link as RouterLink, useParams } from 'react-router-dom'
import { Button, Link, Skeleton } from '@mui/material'

import { ROUTES } from 'src/constants'
import { useScanDraftsCount } from 'src/hooks'
import { joinAbsRoute } from 'src/common/utils'

import { useStyles } from './styles'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

export const Navigation = () => {
  const { data: count, isFetching: countIsFetching } = useScanDraftsCount()
  const { accountId } = useParams()
  const classes = useStyles()

  return (
    <div className={classes.navWrapper}>
      <div>
        <Button
          component={RouterLink}
          to={
            accountId
              ? joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.SCANS_CREATE)
              : joinAbsRoute(ROUTES.SCANS_CREATE)
          }
          variant="contained"
        >
          <HelperWrapper t="manually-add-button-text" ns={ETranslationNs.ScanForm} />
        </Button>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Link
          className={classes.countLink}
          component={RouterLink}
          to={
            accountId
              ? joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.SCANS_DRAFTS)
              : joinAbsRoute(ROUTES.SCANS_DRAFTS)
          }
        >
          <>
            <HelperWrapper t="scan-drafts-header-title" />
            <span>
              &nbsp;
              {countIsFetching ? (
                <Skeleton className={classes.countSkeleton} variant="text" />
              ) : (
                <>({count})</>
              )}
            </span>
          </>
        </Link>
      </div>
    </div>
  )
}
